import { createRouter, createWebHistory } from "vue-router";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { requireAdminSession, waitForAuth } from "../utils/firebaseAuth";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/cohorts",
    name: "cohorts",
    component: () => import("../views/cohorts/MainCohorts.vue"),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/teachers",
    name: "teachers",
    component: () => import("../views/teachers/MainTeachers.vue"),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/Privacy.vue"),
  },
  {
    path: "/video",
    name: "video",
    component: () => import("../views/video-upload/MainVideoUpload.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const getFirebaseApp = () => firebase.app();

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) return next();

  await waitForAuth(getFirebaseApp());
  const session = await requireAdminSession(getFirebaseApp());

  if (session.ok) return next();

  if (session.reason === "not_admin") {
    await getFirebaseApp().auth().signOut();
  }

  return next({
    name: "login",
    query: {redirect: to.fullPath},
  });
});

export default router;
